
import React from 'react';

import SEO from '../components/seo';
import Logo from '../assets/logo.svg';
import styles from './index.module.css';
import Slideshow from '../components/slideshow';


const IndexPage = () => (
  <Slideshow>
    <SEO title="Start" />
    <div
      className={styles.logo}
    >
      <Logo />
    </div>
    <footer
      className={styles.footer}
    >
      <a
        style={{
          fontSize: '1.2rem',
          textDecoration: 'none',
          color: '#fff',
          display: 'block',
          margin: '0 0 1rem 0',
        }}
        href="https://www.google.com/maps/place/S:t+Paul+Bageri/@59.3177606,18.0619284,17z/data=!3m1!4b1!4m5!3m4!1s0x465f776a82baa969:0xccb5fa6b8b5f4eb1!8m2!3d59.3177606!4d18.0641171"
      >
        <div className={styles.infoContainer}>
          <h3 className={styles.infoHeader}>Adress</h3>
          <p>Sankt Paulsgatan 24</p>
          <p>118 47 Stockholm</p>
        </div>
      </a>
      <div className={styles.infoContainer}>
        <h3 className={styles.infoHeader}>Öppetider</h3>
        <p>Mån - Fre: 07:00 - 19:00</p>
        <p>Lör - Sön: 08:00 - 18:00</p>
      </div>
      <div className={styles.infoContainer}>
        <h3 className={styles.infoHeader}>Kontakt</h3>
        <a
          style={{
            textDecoration: 'none',
            color: '#fff',
          }}
          className={styles.link}
          href="tel:08-212221"
        >
          Telefon: 08 - 21 22 21
        </a>
        <a
          style={{
            textDecoration: 'none',
            color: '#fff',
          }}
          className={styles.link}
          href="https://www.instagram.com/stpaulbageri/"
        >
          Instagram: @stpaulbageri
        </a>
      </div>
    </footer>
  </Slideshow>
);

export default IndexPage;
